import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as HomeIcon} from "assets/img/home.svg";

import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function DashboardItem(props) {
    const {currentPath} = useContext(SidebarContext);

    return (
        <SidebarItem
            isTopLevel
            icon={<HomeIcon />}
            to={OMSRoutes.PICKING}
            selected={currentPath === OMSRoutes.PICKING}
        >
            <FormattedMessage id='sidebar.item.dashboard' />
        </SidebarItem>
    );
}

export default DashboardItem;
